const listeners = new Set();

// 💡 [핵심] 전역 저장소를 단일화합니다.
// window에 이미 있으면 그것을 쓰고, 없으면 초기값을 생성하여 등록합니다.
const _initialConfig = {
	ux: { nativeOverride: false, theme: 'light' },
	board: { readOnly: false },
	cssPath: "",
	debug: false
};

if (typeof window !== 'undefined' && !window.__NINE_GLOBAL_CONFIG__) {
	window.__NINE_GLOBAL_CONFIG__ = _initialConfig;
}

// 이제 모든 모듈의 _config는 동일한 window 객체 메모리를 가리킵니다.
const _config = typeof window !== 'undefined' ? window.__NINE_GLOBAL_CONFIG__ : _initialConfig;

export const subscribeConfig = (fn) => {
	listeners.add(fn);
	fn('all', _config);
	return () => listeners.delete(fn);
};

// Proxy 역시 전역 저장소인 _config를 조작합니다.
export const config = new Proxy(_config, {
	set(target, prop, value) {
		target[prop] = value;
		listeners.forEach(fn => fn(prop, target));
		return true;
	},
	get(target, prop) {
		return target[prop];
	}
});

export const nine = {
	config: config,

	// Getter에서 window.nine까지 확인할 필요도 없습니다.
	// 이미 config 자체가 전역 저장소(__NINE_GLOBAL_CONFIG__)를 바라보고 있기 때문입니다.
	get cssPath() {
		return this.config.cssPath || "";
	},

	setup(options = {}) {
		Object.entries(options).forEach(([key, value]) => {
			// 깊은 병합 지원
			if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
				this.config[key] = { ...this.config[key], ...value };
			} else {
				this.config[key] = value;
			}
		});

		// 다른 모듈에서 window.nine으로 접근할 수 있도록 보장
		if (typeof window !== 'undefined') {
			window.nine = window.nine || this;
		}
	}
};